import React from 'react';
import { HeroSection } from '../components/sales/HeroSection';
import { InsideSection } from '../components/sales/InsideSection';
import { PainSection } from '../components/sales/PainSection';
import { SolutionSection } from '../components/sales/SolutionSection';
import { DifferentSection } from '../components/sales/DifferentSection';
import { VolumesSection } from '../components/sales/VolumesSection';
import { VisualSection } from '../components/sales/VisualSection';
import { BonusesSection } from '../components/sales/BonusesSection';
import { AudienceSection } from '../components/sales/AudienceSection';
import { BeforeAfterSection } from '../components/sales/BeforeAfterSection';
import { OfferSection } from '../components/sales/OfferSection';
import { FaqSection } from '../components/sales/FaqSection';
import { FinalSection } from '../components/sales/FinalSection';
import { SiteFooter } from '../components/sales/SiteFooter';
export function SalesPage() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-brand-ivory font-body text-brand-charcoal" data-id="element-211" data-mp="3ajq7wndj1x4p">
      <header className="border-b border-brand-charcoal/10 bg-brand-paper" data-id="element-212" data-mp="35t04hfonw4cn">
        <div className="mx-auto flex max-w-6xl items-center justify-center px-5 py-3 lg:px-8" data-id="element-213" data-mp="35qx5451mcyv9">
          <p className="font-body text-[11px] font-semibold uppercase tracking-[0.22em] text-brand-charcoal" data-id="element-214" data-mp="30ru9tcbfy70h">
            Cosmetology Instructor Ready™
          </p>
        </div>
      </header>

      <main data-id="element-215" data-mp="3tht17ed3yg8b">
        <HeroSection data-id="element-216" data-mp="3tg88zve9n9dm" />
        <InsideSection data-id="element-217" data-mp="3ojraq8dcremt" />
        <PainSection data-id="element-218" data-mp="3okj4ddne32ag" />
        <SolutionSection data-id="element-219" data-mp="3ok0z5rir1dqe" />
        <DifferentSection data-id="element-220" data-mp="3ohom9srultk7" />
        <VolumesSection data-id="element-221" data-mp="3jjvewwet6tic" />
        <VisualSection data-id="element-222" data-mp="3jj3jbll7ovs2" />
        <BonusesSection data-id="element-223" data-mp="3jilgg641njb6" />
        <AudienceSection data-id="element-224" data-mp="3fitfofkw6hgd" />
        <BeforeAfterSection data-id="element-225" data-mp="3fjkyepte4kp8" />
        <OfferSection data-id="element-226" data-mp="3fi9umpzy3cy4" />
        <FaqSection data-id="element-227" data-mp="3fkw1soixbqft" />
        <FinalSection data-id="element-228" data-mp="284zqwju9vfp4" />
      </main>

      <SiteFooter data-id="element-229" data-mp="286axerf3r1jx" />
    </div>;
}